import React, { useMemo, useRef, useState } from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import { tags_utils } from '../utils/frfr-tags-utils';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';
import UniFormgenTagBtn from './UniFormgenTagBtn';


// UniFormgenSpecialTagsCsv


//
const _custom_hook = (value, _update_tags_csv, tagsSuggestions, disabled) => {
  let tags_csv = '';
  if (typeof value === 'string') {
    tags_csv = value;
  }
  const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(tags_csv);
  const [newTag, setNewTag] = useState('');
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);

  const normalizedSuggestions = useMemo(() => {
    const raw_arr = Array.isArray(tagsSuggestions) ? tagsSuggestions : [];
    const unique = [];
    raw_arr.forEach(item => {
      const fixed = tags_utils.fix_tag_lowercase(item);
      if (fixed !== '' && !unique.includes(fixed)) {
        unique.push(fixed);
      }
    });
    unique.sort((a, b) => a.localeCompare(b));
    return unique;
  }, [tagsSuggestions]);

  const filteredSuggestions = useMemo(() => {
    const query = tags_utils.fix_tag_lowercase(newTag);
    if (query.length < 2) {
      return [];
    }
    const selectedLower = tags_arr.map(item => item.toLowerCase());
    return normalizedSuggestions
      .filter(item => !selectedLower.includes(item) && item.startsWith(query));
  }, [newTag, normalizedSuggestions, tags_arr]);

  const _reset_suggestions_nav = () => {
    setActiveSuggestionIndex(-1);
  };

  const _add_new_tag = (new_tag) => {
    let added = false;
    const fixed_tag = tags_utils.fix_tag_lowercase(new_tag);
    if (fixed_tag !== '') {
      if (tags_utils.is_tag_exist_in_tags_arr(tags_arr, fixed_tag)) {
        // tag already exist
      } else { // add new tag
        const updated_tags_arr = [...tags_arr, fixed_tag];
        // const updated_tags_csv = updated_tags_arr.join(tags_utils.TAGS_CSV_SEPARATOR);
        const updated_tags_csv = tags_utils.convert_tags_arr_to_tags_csv(updated_tags_arr);
        _update_tags_csv(updated_tags_csv);
        added = true;
      }
    }
    // RESET newTag input state
    setNewTag('');
    _reset_suggestions_nav();
    setShowSuggestions(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
    return added;
  };

  const _extract_first_tag = (str) => {
    if (typeof str !== 'string') {
      return '';
    }
    return str.split(tags_utils.TAGS_CSV_SEPARATOR)[0];
  };

  const handleChangeNewTagInput = (e) => {
    if (disabled === true) {
      return;
    }
    const value = e.target.value;
    if (typeof value === 'string') {
      const exploded_tag = value.split(tags_utils.TAGS_CSV_SEPARATOR);
      if (exploded_tag.length > 1) { // user entered comma ',' character
        const prepared_tag = exploded_tag[0];
        _add_new_tag(prepared_tag);
        return;
      }
    }
    setNewTag(value);
    _reset_suggestions_nav();
    setShowSuggestions(true);
  };

  const handleSubmitNewTagForm = (e) => { // user pressed enter
    e.preventDefault(); // Disables the default browser POST/GET action
    if (disabled === true) {
      return;
    }
    if (filteredSuggestions.length > 0 && activeSuggestionIndex >= 0 && activeSuggestionIndex < filteredSuggestions.length) {
      _add_new_tag(filteredSuggestions[activeSuggestionIndex]);
      return;
    }
    if (typeof newTag === 'string') {
      const prepared_tag = _extract_first_tag(newTag);
      _add_new_tag(prepared_tag);
    }
  };

  const handleInputKeyDown = (e) => {
    if (disabled === true) {
      return;
    }
    if (e.key === 'ArrowDown') {
      if (filteredSuggestions.length > 0) {
        e.preventDefault();
        setShowSuggestions(true);
        setActiveSuggestionIndex(index => {
          if (index < 0) {
            return 0;
          }
          return (index + 1) % filteredSuggestions.length;
        });
      }
    } else if (e.key === 'ArrowUp') {
      if (filteredSuggestions.length > 0) {
        e.preventDefault();
        setShowSuggestions(true);
        setActiveSuggestionIndex(index => {
          if (index < 0) {
            return filteredSuggestions.length - 1;
          }
          return index === 0 ? filteredSuggestions.length - 1 : index - 1;
        });
      }
    } else if (e.key === 'Escape') {
      setShowSuggestions(false);
      _reset_suggestions_nav();
    }
  };

  //
  const _handleTagDelete = (target_tag) => {
    // setFormStateMeta(state => {
    if (true) {
      const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(tags_csv);
      // if (tags_arr.includes(target_tag)) {
      // if (tags_utils.is_tag_exist_in_tags_csv(tags_csv, target_tag)) {
      if (tags_utils.is_tag_exist_in_tags_arr(tags_arr, target_tag)) {
        const updated_tags_arr = tags_arr.filter(item => {
          // if (tag === target_tag) {
          if (item.toLowerCase() === target_tag.toLowerCase()) {
            // BINGO match CASE INSENSITIVE
            return false; // delete
          }
          return true; // all other stay
        });
        // const updated_tags_csv = updated_tags_arr.join(tags_utils.TAGS_CSV_SEPARATOR);
        const updated_tags_csv = tags_utils.convert_tags_arr_to_tags_csv(updated_tags_arr);
        /*
        return {
          ...state,
          tags_csv: updated_tags_csv,
        };
        */
        _update_tags_csv(updated_tags_csv);
      }
    }
    // 
    // return state; // return unchanged
    // });
  };

  const handleInputFocus = () => {
    if (disabled !== true) {
      setShowSuggestions(true);
    }
  };

  const handleInputBlur = () => {
    // Delay needed so suggestion onMouseDown can run before closing the list.
    setTimeout(() => {
      setShowSuggestions(false);
      _reset_suggestions_nav();
    }, 120);
  };

  const handleClickSuggestion = (suggestion) => {
    if (disabled === true) {
      return;
    }
    _add_new_tag(suggestion);
  };

  return {
    tags_arr,
    newTag,
    filteredSuggestions,
    activeSuggestionIndex,
    showSuggestions,
    inputRef,
    handleChangeNewTagInput,
    handleInputKeyDown,
    handleInputFocus,
    handleInputBlur,
    handleClickSuggestion,
    handleSubmitNewTagForm,
    _handleTagDelete,
  };
};


// DEFAULT COMPONENT
const UniFormgenSpecialTagsCsv = (props) => {
  // const timeoutRef = useRef(null);
  // const [clAnimation, setClAnimation] = useState("");

  const {
    warningtip,
    // valueToDisplay,
  } = useFormGeneratorField(props);

  //
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let disabled = false;
  if (params.disabled === true) {
    disabled = true;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
    disabled = true; //
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }

  /*
  useEffect(() => {
    // animate when value change
    setClAnimation(" uniformcompo__field--animate-value-changed");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      //
      setClAnimation("");
    }, 334);
    // componentWillUnmount
    return () => clearTimeout(timeoutRef.current);
  }, [formState[name]]);
  */

  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }
  if (readonly === true) {
    // FIX (According to HTML specs, the select tag in HTML doesn't have a readonly attribute, only a disabled attribute.)
    // handleChange = () => { }; // disable handle change for readonly
    handleChange = null; // disable handle change for readonly
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  // let cl = 'uniformcompo__field' + clAnimation + extraClass;
  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  let infotip = 'name: ' + name;

  let placeholder = null;
  if (typeof params.placeholder === 'string' && params.name !== '') {
    placeholder = params.placeholder;
  }

  //

  const value = formState[name];

  //
  // let _handleChange = (e) => {
  const _update_tags_csv = (value) => {
    if (typeof handleChange !== 'function') {
      return;
    }
    let virtual_e = {
      target: {
        name: name,
        value: value
      }
    }
    handleChange(virtual_e);
  };
  //
  const {
    tags_arr,
    newTag,
    filteredSuggestions,
    activeSuggestionIndex,
    showSuggestions,
    inputRef,
    handleChangeNewTagInput,
    handleInputKeyDown,
    handleInputFocus,
    handleInputBlur,
    handleClickSuggestion,
    handleSubmitNewTagForm,
    _handleTagDelete,
  } = _custom_hook(value, _update_tags_csv, props.tagsSuggestions, disabled);
  //

  return (
    <div className={cl} style={style}>
      {/*<label htmlFor={name}>{params.label}</label>*/}
      <label htmlFor={name}>
        {
          tooltip ? (<abbr title={tooltip}>{params.label}</abbr>) : (params.label)
        }
      </label>
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }
      <UniFormcompoErrorInField error={formErrors[name]} />

      <div className="uniformcompo__widget-tags-csv">
        <div className="uniformcompo__widget-tags-csv__fake-input">
          <div className="uniformcompo__widget-tags-csv__tags-vector">
            {
              tags_arr.map((tag, index) => {
                return (
                  <UniFormgenTagBtn
                    key={tag + '-' + index}
                    title={tag}
                    added
                    withDelete
                    handleClickDelete={() => { _handleTagDelete(tag) }}
                  />
                );
              })
            }
            <div className="uniformcompo__widget-tags-csv__fake-input__real-input-container">
              <form onSubmit={handleSubmitNewTagForm}>
                <input
                  className="uniformcompo__widget-tags-csv__fake-input__real-input"
                  type="text"
                  name={"fake_input"}
                  value={newTag}
                  ref={inputRef}
                  onChange={handleChangeNewTagInput}
                  onKeyDown={handleInputKeyDown}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  placeholder={placeholder || 'Type tag and press Enter'}
                  autoComplete="off"
                  disabled={disabled}
                />
              </form>
              {
                showSuggestions && filteredSuggestions.length > 0 && !disabled ? (
                  <div className="uniformcompo__widget-tags-csv__suggestions" role="listbox" aria-label="Tag suggestions">
                    {
                      filteredSuggestions.map((suggestion, index) => {
                        const active = index === activeSuggestionIndex;
                        return (
                          <button
                            key={suggestion}
                            type="button"
                            className={"uniformcompo__widget-tags-csv__suggestion-item" + (active ? ' active' : '')}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleClickSuggestion(suggestion);
                            }}
                          >
                            {suggestion}
                          </button>
                        );
                      })
                    }
                  </div>
                ) : null
              }
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UniFormgenSpecialTagsCsv;